(() => {
  const SELECTOR = '.coastd-roll';

  function parseProducts(root) {
    const products = {};

    root.querySelectorAll('[data-coastd-product]').forEach((script) => {
      try {
        const product = JSON.parse(script.textContent);
        products[product.handle] = product;
      } catch (error) {
        console.warn('Coast’d camera roll: product data could not be read.', error);
      }
    });

    return products;
  }

  function initialise(root) {
    if (!root || root.dataset.coastdInitialised === 'true') return;
    root.dataset.coastdInitialised = 'true';

    const carousel = root.querySelector('.coastd-roll__carousel');
    const slides = [...root.querySelectorAll('[data-coastd-slide]')];
    const progress = root.querySelector('[data-coastd-progress]');
    const current = root.querySelector('[data-coastd-current]');
    const drawer = root.querySelector('[data-coastd-drawer]');
    const backdrop = root.querySelector('[data-coastd-backdrop]');
    const closeButton = root.querySelector('[data-coastd-close]');
    const drawerImageWrap = root.querySelector('.coastd-roll__drawer-image-wrap');
    const drawerImage = root.querySelector('[data-coastd-drawer-image]');
    const drawerTitle = root.querySelector('[data-coastd-drawer-title]');
    const drawerPrice = root.querySelector('[data-coastd-drawer-price]');
    const options = root.querySelector('[data-coastd-options]');
    const addButton = root.querySelector('[data-coastd-add]');
    const addLabel = root.querySelector('[data-coastd-add-label]');
    const addPrice = root.querySelector('[data-coastd-add-price]');
    const productLink = root.querySelector('[data-coastd-product-link]');
    const errorMessage = root.querySelector('[data-coastd-error]');
    const products = parseProducts(root);

    let activeProduct = null;
    let activeVariant = null;
    let lastTrigger = null;
    let swipeStartY = 0;
    let swipeLastY = 0;
    let swipeActive = false;

    const cleanMoney = (value) => {
      const element = document.createElement('span');
      element.innerHTML = value || '';
      return element.textContent || '';
    };

    const updateProgress = () => {
      if (!carousel || !slides.length || !progress || !current) return;

      const slideWidth = slides[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(carousel).columnGap || 0);
      const index = Math.max(
        0,
        Math.min(slides.length - 1, Math.round(carousel.scrollLeft / (slideWidth + gap)))
      );

      current.textContent = String(index + 1).padStart(2, '0');
      progress.style.width = `${((index + 1) / slides.length) * 100}%`;
    };

    if (carousel) {
      carousel.addEventListener('scroll', updateProgress, { passive: true });
      window.addEventListener('resize', updateProgress);
      updateProgress();
    }

    const setVariant = (variant, button) => {
      activeVariant = variant;
      options.querySelectorAll('.coastd-roll__variant').forEach((item) => {
        item.classList.toggle('is-selected', item === button);
        item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
      });
      addPrice.textContent = cleanMoney(variant.price);
      addButton.disabled = !variant.available;
      addLabel.textContent = variant.available ? 'add to bag' : 'sold out';
    };

    const renderOptions = (product) => {
      options.innerHTML = '';
      const meaningfulOption = product.options.length && product.options[0] !== 'Title';

      if (!meaningfulOption) {
        options.hidden = true;
        activeVariant = product.variants.find((variant) => variant.available) || product.variants[0];
        addPrice.textContent = cleanMoney(activeVariant ? activeVariant.price : product.price);
        addButton.disabled = !activeVariant || !activeVariant.available;
        return;
      }

      options.hidden = false;
      const seen = new Set();

      product.variants.forEach((variant) => {
        if (seen.has(variant.option1)) return;
        seen.add(variant.option1);

        const matchingVariants = product.variants.filter((item) => item.option1 === variant.option1);
        const availableVariant = matchingVariants.find((item) => item.available);
        const chosenVariant = availableVariant || matchingVariants[0];
        const button = document.createElement('button');

        button.type = 'button';
        button.className = 'coastd-roll__variant';
        button.textContent = variant.option1;
        button.disabled = !availableVariant;
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', () => setVariant(chosenVariant, button));
        options.appendChild(button);

        if (!activeVariant && availableVariant) setVariant(chosenVariant, button);
      });
    };

    const openDrawer = (trigger) => {
      const product = products[trigger.dataset.productHandle];
      if (!product || !drawer) return;

      lastTrigger = trigger;
      activeProduct = product;
      activeVariant = null;
      errorMessage.textContent = '';
      addButton.classList.remove('is-added');
      addLabel.textContent = 'add to bag';
      drawerTitle.textContent = product.title;
      drawerPrice.textContent = cleanMoney(product.price);
      drawerImage.src = product.featuredImage;
      drawerImage.alt = product.title;
      productLink.href = product.url;

      renderOptions(product);

      drawer.classList.add('is-open');
      backdrop.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('coastd-drawer-open');
      closeButton.focus();
    };

    const closeDrawer = () => {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('coastd-drawer-open');
      if (lastTrigger) lastTrigger.focus();
    };

    const getCartRenderer = () =>
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    const getCartSections = (cartRenderer) => {
      if (cartRenderer && typeof cartRenderer.getSectionsToRender === 'function') {
        return cartRenderer.getSectionsToRender().map((section) => section.id);
      }

      return ['cart-icon-bubble', 'cart-drawer', 'cart-notification'];
    };

    const publishCartUpdate = (result) => {
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: `coastd-camera-roll-${root.dataset.sectionId}`,
          productVariantId: activeVariant?.id,
          cartData: result
        });
      }
    };

    const refreshAndOpenCart = async (cartRenderer, addResult) => {
      const cartUrl = window.routes?.cart_url || '/cart';

      try {
        let sections = null;
        let parsedDrawer = null;

        for (let attempt = 0; attempt < 2; attempt += 1) {
          const separator = cartUrl.includes('?') ? '&' : '?';
          const response = await fetch(
            `${cartUrl}${separator}sections=cart-drawer,cart-icon-bubble&_=${Date.now()}`,
            {
              cache: 'no-store',
              credentials: 'same-origin',
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json'
              }
            }
          );

          if (!response.ok) throw new Error('Cart sections could not be refreshed.');
          sections = await response.json();
          parsedDrawer = new DOMParser().parseFromString(
            sections['cart-drawer'] || '',
            'text/html'
          ).querySelector('cart-drawer');

          if (parsedDrawer && !parsedDrawer.classList.contains('is-empty')) break;
          if (attempt === 0) await new Promise((resolve) => setTimeout(resolve, 180));
        }

        if (!parsedDrawer || parsedDrawer.classList.contains('is-empty')) {
          throw new Error('Shopify returned stale empty-cart markup.');
        }

        const currentDrawer = document.querySelector('cart-drawer');
        let freshDrawer = null;

        if (currentDrawer) {
          freshDrawer = parsedDrawer;
          currentDrawer.replaceWith(freshDrawer);
        }

        const currentBubble = document.querySelector('#cart-icon-bubble');
        const bubbleMarkup = sections['cart-icon-bubble'];

        if (currentBubble && bubbleMarkup) {
          const parsed = new DOMParser().parseFromString(bubbleMarkup, 'text/html');
          const freshBubble = parsed.querySelector('#cart-icon-bubble');
          if (freshBubble) currentBubble.replaceWith(freshBubble);
        }

        const updatedRenderer = freshDrawer || document.querySelector('cart-drawer');
        if (updatedRenderer && typeof updatedRenderer.open === 'function') {
          requestAnimationFrame(() => updatedRenderer.open());
        }

        return Boolean(updatedRenderer);
      } catch (error) {
        console.warn('Coast’d camera roll: full cart refresh failed.', error);

        if (cartRenderer && typeof cartRenderer.renderContents === 'function') {
          cartRenderer.renderContents(addResult);
          return true;
        }

        return false;
      }
    };

    root.querySelectorAll('[data-coastd-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => openDrawer(trigger));
    });

    closeButton?.addEventListener('click', closeDrawer);
    backdrop?.addEventListener('click', closeDrawer);

    const resetSwipe = () => {
      swipeStartY = 0;
      swipeLastY = 0;
      swipeActive = false;
      if (!drawer) return;
      drawer.style.removeProperty('transition');
      drawer.style.removeProperty('transform');
    };

    drawer?.addEventListener('touchstart', (event) => {
      if (
        !window.matchMedia('(max-width: 749px)').matches ||
        !drawer.classList.contains('is-open') ||
        event.touches.length !== 1
      ) return;

      const touchStartedOnImage = drawerImageWrap?.contains(event.target);
      const touchStartedNearTop =
        event.touches[0].clientY - drawer.getBoundingClientRect().top <= 72;

      if (!touchStartedOnImage && !touchStartedNearTop) return;

      swipeStartY = event.touches[0].clientY;
      swipeLastY = swipeStartY;
      swipeActive = true;
    }, { passive: true });

    drawer?.addEventListener('touchmove', (event) => {
      if (!swipeActive || event.touches.length !== 1) return;

      swipeLastY = event.touches[0].clientY;
      const distance = Math.max(0, swipeLastY - swipeStartY);
      if (!distance) return;

      event.preventDefault();
      drawer.style.transition = 'none';
      drawer.style.transform = `translateY(${Math.min(distance, 220)}px)`;
    }, { passive: false });

    const finishSwipe = () => {
      if (!swipeActive) return;

      const distance = swipeLastY - swipeStartY;
      resetSwipe();

      if (distance >= 72) closeDrawer();
    };

    drawer?.addEventListener('touchend', finishSwipe, { passive: true });
    drawer?.addEventListener('touchcancel', resetSwipe, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer?.classList.contains('is-open')) closeDrawer();
    });

    addButton?.addEventListener('click', async () => {
      if (!activeVariant || !activeVariant.available) return;

      addButton.disabled = true;
      errorMessage.textContent = '';
      addLabel.textContent = 'adding…';

      try {
        const cartRenderer = getCartRenderer();
        const sections = getCartSections(cartRenderer);
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: activeVariant.id,
            quantity: 1,
            sections: sections.join(','),
            sections_url: window.location.pathname
          })
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'This item could not be added.');

        addButton.classList.add('is-added');
        addLabel.textContent = 'added to bag ✓';

        closeDrawer();

        const cartWasRendered = await refreshAndOpenCart(cartRenderer, result);
        if (!cartWasRendered) {
          document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
            detail: { product: activeProduct, variant: activeVariant, result }
          }));
        }

        publishCartUpdate(result);

        if (!cartWasRendered) {
          const cartBubble = document.querySelector('#cart-icon-bubble');
          const bubbleMarkup = result.sections?.['cart-icon-bubble'];
          if (cartBubble && bubbleMarkup) {
            const parsed = new DOMParser().parseFromString(bubbleMarkup, 'text/html');
            const freshBubble = parsed.querySelector('#cart-icon-bubble');
            if (freshBubble) cartBubble.innerHTML = freshBubble.innerHTML;
          }
        }
      } catch (error) {
        errorMessage.textContent = error.message;
        addLabel.textContent = 'add to bag';
      } finally {
        addButton.disabled = false;
      }
    });
  }

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll(SELECTOR).forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
